/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import { useNextRouter } from '@/data/Content/_NextRouter'; 
import { useCallback } from 'react';

export const useHelloRetail = () => {

	const router = useNextRouter();	 
	const routeToPdp = useCallback((pdpPath: string) =>  {  
		router.push(pdpPath);	
		return true;
	}, [  router.asPath]);  

	return { routeToPdp };
};
